module.exports = __webpack_public_path__ + "media/customizations/sunterra/logo-bcfd358ae764ea4a713d6604c107bd47.png";